import URI from "urijs";
import {throwError} from "rxjs";
import {ajaxAuthed, API_BASE, RESULT_LIMIT} from "./common";
import {APIError} from "../common/errors";

export function getBidDocumentRequest(subroute) {
  return ({id, bidId, offset}) => {
    if (!bidId) {
      return throwError(new Error('no bid id specified'));
    }
    let url;
    if (id) {
      url = URI.joinPaths(API_BASE, 'bids', bidId, subroute, id);
    } else {
      url = URI.joinPaths(API_BASE, 'bids', bidId, subroute);
      let query = { limit: RESULT_LIMIT, offset };
      url.query(URI.buildQuery(query));
    }
    return ajaxAuthed({ url: url.toString() });
  };
}

export function getBids$({ id, offset, sortby, sortoffset, order, filterby, from, to, status, limit, search }) {
  let url;
  if (id) {
    url = URI.joinPaths(API_BASE, 'bids', id);
  } else {
    url = URI.joinPaths(API_BASE, 'bids');
    url.query(URI.buildQuery({ limit: Math.min(limit, RESULT_LIMIT) || RESULT_LIMIT, offset, sortby, sortoffset, sortorder: order, filterby, filterstart: from, filterend: to, status, q: search }));
  }
  return ajaxAuthed({ url: url.toString() });
}

export function getBidsIndex$({ id, offset, sortby, sortoffset, order, filterby, from, to, status, limit, search }) {
  let url;
  url = URI.joinPaths(API_BASE, 'bids');
  url.query(URI.buildQuery({ limit: Math.min(limit, RESULT_LIMIT) || RESULT_LIMIT, offset, sortby, sortoffset, sortorder: order, filterby, filterstart: from, filterend: to, status, index: '', q: search }));
  return ajaxAuthed({ url: url.toString() });
}

export function getBidsMulti$({ ids }) {
  if (!ids) throw new APIError('getBidsMulti$: no id specified in API call');
  let url = URI.joinPaths(API_BASE, 'bids');
  url.query(URI.buildQuery({ id: ids }, true));
  return ajaxAuthed({ url: url.toString() });
}

export function createBid$({ bid }) {
  let url = URI.joinPaths(API_BASE, 'bids');
  return ajaxAuthed({ url: url.toString(), method: 'POST', body: bid, headers: { 'Content-Type': 'application/json'} });
}

export function updateBid$({ bidId, bid }) {
  if (!bid) throw new APIError('no bid record provided to updateBid');
  if (!bidId) throw new APIError('no bid ID found in bid record');
  let url = URI.joinPaths(API_BASE, 'bids', bidId);
  return ajaxAuthed({ url: url.toString(), method: 'PUT', body: bid, headers: { 'Content-Type': 'application/json'} });
}

export function deleteBid$({ bidId }) {
  if (!bidId) throw new APIError('no bid id specified for deleteBid');
  let url = URI.joinPaths(API_BASE, 'bids', bidId);
  return ajaxAuthed({ url: url.toString(), method: 'DELETE' });
}

export function getBidArchives$({ id, offset, sortby, sortoffset, sortorder, from, to, q }) {
  let query = {
    limit: RESULT_LIMIT,
    id,
    offset,
    sortby,
    sortoffset,
    sortorder,
    from,
    to,
    q
  };
  let url = URI.joinPaths(API_BASE, 'bids', 'archives');
  url = url.query(URI.buildQuery(query));
  return ajaxAuthed({ url: url.toString()});
}

export function getBidArchive$({ bidId }) {
  let url = URI.joinPaths(API_BASE, 'bids', 'archives', bidId);
  return ajaxAuthed({ url: url.toString()});
}

export function archiveBid$({ bidId }) {
  if (!bidId) throw new APIError('no bid id specified for archiveBid');
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'archives');
  return ajaxAuthed({ url: url.toString(), method: 'PUT', headers: { 'Content-Type': 'application/json'} });
}

export function convertBidToProject$({ bidId, inviteUserIds = [] }) {
  if (!bidId) throw new APIError('no bid id specified for convertBidToProject');
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'convert');
  return ajaxAuthed({ url: url.toString(), method: 'POST', body: inviteUserIds, headers: { 'Content-Type': 'application/json'} });
}

export function setBidViewed$({ bidId }) {
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'seen');
  return ajaxAuthed({ url: url.toString(), method: 'POST' });
}

export function getBidInvites$({ bidId, id, offset, q }) {
  let query = {
    limit: RESULT_LIMIT,
    id,
    offset,
    q,
  };
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'invites');
  url.query(URI.buildQuery(query));
  return ajaxAuthed({ url: url.toString() });
}

export function createBidInvites$({ bidId, inviteUserIds = [] }) {
  if (!bidId) throw new APIError('no bid id specified for createBidInvites');
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'invites');
  return ajaxAuthed({ url: url.toString(), method: 'POST', body: inviteUserIds, headers: { 'Content-Type': 'application/json'} });
}

export function leaveBid$({ bidId }) {
  if (!bidId) throw new APIError('no bid id specified for leaveBid');
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'invites');
  return ajaxAuthed({ url: url.toString(), method: 'DELETE' });
}

export function getBidInvitesAccepted$({ bidId, offset, id, q }) {
  if (!bidId) throw new APIError('no bid id specified for getBidInvitesAccepted');
  let query = {
    offset,
    id,
    q,
  };
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'invites', 'accepted');
  url.query(URI.buildQuery(query));
  return ajaxAuthed({ url: url.toString() });
}

export function acceptBidInvite$({ bidId }) {
  if (!bidId) throw new APIError('no bid id specified for acceptBidInvite');
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'invites', 'accepted');
  return ajaxAuthed({ url: url.toString(), method: 'PUT', headers: { 'Content-Type': 'application/json'} });
}

export function getBidInvitesDeclined$({ bidId, offset, id, q }) {
  if (!bidId) throw new APIError('no bid id specified for getBidInvitesDeclined');
  let query = {
    offset,
    id,
    q,
  };
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'invites', 'declined');
  url.query(URI.buildQuery(query));
  return ajaxAuthed({ url: url.toString() });
}

export function declineBidInvite$({ bidId }) {
  if (!bidId) throw new APIError('no bid id specified for declineBidInvite');
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'invites', 'declined');
  return ajaxAuthed({ url: url.toString(), method: 'PUT', headers: { 'Content-Type': 'application/json'} });
}

export function createEmailBidInvites$({ bidId, inviteUserEmails = [] }) {
  if (!bidId) throw new APIError('no bid id specified for createEmailBidInvites');
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'invites', 'emails');
  return ajaxAuthed({ url: url.toString(), method: 'POST', body: inviteUserEmails, headers: { 'Content-Type': 'application/json'} });
}

export function createBidContactListInvites$({ bidId, contactListIds = [] }) {
  if (!bidId) throw new APIError('no bid id specified for createBidContactListInvites');
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'invites', 'contact-lists');
  return ajaxAuthed({ url: url.toString(), method: 'POST', body: contactListIds, headers: { 'Content-Type': 'application/json'} });
}

export function getBidInvitesPending$({ bidId, offset, id, q }) {
  if (!bidId) throw new APIError('no bid id specified for getBidInvitesPending');
  let query = {
    offset,
    id,
    q,
  };
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'invites', 'pending');
  url.query(URI.buildQuery(query));
  return ajaxAuthed({ url: url.toString() });
}

export function getBidInviteById$({ bidId, userId }) {
  if (!bidId) throw new APIError('no bid id specified for getBidInviteById');
  if (!userId) throw new APIError('no user id specified for getBidInviteById');
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'invites', userId);
  return ajaxAuthed({ url: url.toString() });
}

export function updateBidInvitePermissions$({ bidId, userId, role }) {
  if (!bidId) throw new APIError('no bid id specified for updateBidInvitePermissions');
  if (!userId) throw new APIError('no user id specified for updateBidInvitePermissions');
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'invites', userId);
  return ajaxAuthed({ url: url.toString(), method: 'PUT', body: { role }, headers: { 'Content-Type': 'application/json'}});
}

export function deleteBidInvite$({ bidId, userId }) {
  if (!bidId) throw new APIError('no bid id specified for deleteBidInvite');
  if (!userId) throw new APIError('no user id specified for deleteBidInvite');
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'invites', userId);
  return ajaxAuthed({ url: url.toString(), method: 'DELETE' });
}

export function getBidPhoto$({ bidId }) {
  if (!bidId) throw new APIError('no bid id specified for getBidPhoto');
  let url = URI.joinPaths(API_BASE, 'bids', bidId, 'photos');
  return ajaxAuthed({ url: url.toString() });
}



// WEBPACK FOOTER //
// ./src/services/bids.js